import React, { useContext } from "react";
import Card from "../components/Card";
import { ThemeContext } from "../themeProvider";
import one from "./Images/one.png"
import two from "./Images/two.png"
import three from "./Images/three.png"
import time1 from './Images/time1.jpeg'
import time2 from './Images/time2.jpeg'
import time3 from './Images/time3.jpeg'
// import ideakart from './Images/ideakart.jpeg'
import calculator from './Images/calculator.png'
import blog from './Images/blog.png'
import lifestyle from './Images/lifestyle.png'
import lifestyle1 from './Images/lifestyle1.png'

const Projects = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  
  const Projecs = [
    {
      id: 1,
      projectName: "i-Blog , Blog Application",
      imageUrl:
        blog,
      imageUrl1:
        blog,
      imageUrl2:
        blog,
      descripriction:"i-Blog is a Blog Application where user can write our blog , and user can also able to Update and Delete, and store in server and ",
      sourceCode: "https://github.com/anurag-pverma/i-Blog",
      netlifyLink: "https://i-blogs.netlify.app/",
      toolsStack:"HTML, CSS,JavaScript ,React.js, Redux, Redux-thunk, Charkar-Ui , Api, Github"
    },
    {
      id: 2,
      projectName: "Smart Money Tracking Full Stack",
      imageUrl1: two,
      imageUrl2:
        three,
      imageUrl:
        one,
      descripriction:
        "An Money Expense tracking application records user's transaction related data. Where beautiful user Interface & easy to use , User Authentication with restricted routing for users, Users record their expenses with a particular category, Every user can create their own accounts Users also able to delete and edit their records. .",
      sourceCode: "https://github.com/anurag-pverma/Smart-Money-Tracking",
      netlifyLink: "https://smart-money-tracking.netlify.app/",
      toolsStack:"React.js , Redux , Express , Node.js , JavaScript JSON Web Tokens , mongoose  Passport.js , node.bycript.js , react-chartjs , Material-UI "},
    {
      id: 3,
      projectName: "Sugar Cosmetics Front-End Devloper",
      imageUrl:
        "https://camo.githubusercontent.com/3b918e247b0c79fc78b7fd6da0e5d2f2521b917f160da34268243d9278f5e34b/68747470733a2f2f692e6962622e636f2f6e77525a43547a2f332e706e67",
      imageUrl1:
        "https://camo.githubusercontent.com/7ae11797818b2dd9ba81f91d5b6df24fc27fc52f3c732075fa2b1c67f2c9ed27/68747470733a2f2f692e6962622e636f2f4e334c776a47382f322e706e67",
      imageUrl2:
        "https://camo.githubusercontent.com/be644878f3000813857486461677236cbc8c2381577a5552b72480a9168db0f1/68747470733a2f2f692e6962622e636f2f503673326735572f352e706e67",
      descripriction:
        "sugarcosmetics is an Indian company of cosmetics products. It is one of the leading company or a brand which intends to make lives of mums & expectant mums better and beautiful. India has a growing market demand for cosmetics. People struggle to find the right shade and product and often switch to big foreign brands.",
      sourceCode: "https://github.com/goutham41/sugarcosmetics-app-clone",
      netlifyLink:
        "https://sugarcosmetics-clone.netlify.app",
        toolsStack:"HTML ,CSS ,SCSS, React, Redux, Github,"
    },
    {
      id: 1,
      projectName: "Clone-TimeCamp Full Stack",
      imageUrl:
        time1,
      imageUrl1:
        time2,
      imageUrl2:
        time3,
      descripriction:
        "TimeCamp is a simple, yet feature-rich time tracking app to help you gain insights into yourprojects and tasks",
      sourceCode: "https://github.com/iamdebobrota/Timecamp-Clone",
      netlifyLink: "https://timecamp.vercel.app/",
      toolsStack:"JavaScript ,React.js, Node.js, Express, MongoDB, Github"
    },
    {
      id: 4,
      projectName: "LifeStyle-clone",
      imageUrl: lifestyle,
      imageUrl1:lifestyle,
      imageUrl2:lifestyle1,
      descripriction:
        "A FulLifestyle is India's premier fashion destination for the latest trends and hottest styles.Part of Dubai based retail and hospitality conglomerate ",
      sourceCode: "https://github.com/anurag-pverma/Lifestyle-project",
      netlifyLink:
        "https://lifestyle-clone.netlify.app/",
        toolsStack:"HTML, CSS, JavaScript, Github,"
    }, 
    {
      id: 5,
      projectName: "Calculator",
      imageUrl: calculator,
      imageUrl1:calculator,
      imageUrl2:calculator,
      descripriction:
        "A Full feledged calculator web application ",
      sourceCode: "https://github.com/anurag-pverma/Calculator-With-React",
      netlifyLink:
        "https://do-calculator.netlify.app/",
        toolsStack:"HTML, CSS, Github, ReactJS,"
    }, 

  ];

  return (
    <div
      id="projects"
      className={darkMode ? "bg-white text-black" : "bg-gray-900 text-white"}
    >
      <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4  pt-18 pb-12">
        <h2 className="text-5xl font-bold px-4 md:px-0 text-center">
          Projects
        </h2>
       
        <div className="mt-8 flex justify-between items-stretch flex-wrap">
          {Projecs.map((ele) => {
            return <Card key={ele.id} {...ele} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Projects;
